export default "__VITE_ASSET__Dpyd4ryq__"